var Widget          = require("../Widget"),
    template        = require("./template.ejs"),
    $               = require("jquery"),
    Events          = require("Events");

var Window = Widget.extend({

    includes: Events,

    options: {
        showHeader: true,
        showFooter: true
    },

    initialize: function(options){
        var that = this;

        Window.__super__.initialize.call(that, options);

        that._container.addClass('omjs-window');

        $(that._container).append(template({
            header: options.headerContent ? options.headerContent : '',
            footer: options.footerContent ? options.footerContent : '',
            content: options.content ? options.content : ''
        }));

        delete options['headerContent'];
        delete options['footerContent'];
        delete options['content'];

        if (!options.showHeader) {
            $(that._container).find('.window-header').remove();
        }
        if (!options.showFooter) {
            $(that._container).find('.window-footer').remove();
        }

        that._body = $(that._container).find('.window-body');
        that._header = $(that._container).find('.window-header');
        that._footer = $(that._container).find('.window-footer');
    },

    onAdd: function(view){
        var that = this,
            bodyTop,
            bodyBottom;

        bodyTop = that._header.outerHeight();
        bodyBottom = that._footer.outerHeight();

        that._body.css({
            'top': bodyTop,
            'bottom': bodyBottom
        });

        $(that._container).on('click', '.close-button', function(event){
            var close = true;
            if (typeof that.options['beforeClose'] == 'function') {
                close = that.options['beforeClose'].call(that);
            }
            if (close === true) {
                that.hide();
                that.fire('close');
            }
        });

        //if (that.options.showHeader) {
        //    that._header.on('mousedown', function(event) {
        //        console.log('asd');
        //    })
        //}
    },

    setContent: function(content) {
        var that = this;

        that._body.empty().append(content);

        return that;
    },

    setHeader: function(content){
        var that = this;

        that._header.empty().append(content);

        return that;
    },

    setFooter: function(content){
        var that = this;

        that._footer.empty().append(content);

        return that;
    }
});

module.exports = Window;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Window/Window.js
// module id = 207
// module chunks = 0